
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProfileQualificationRequest,
  ProfileQualificationResource,
} from '../models';
import {
    ProfileQualificationRequestFromJSON,
    ProfileQualificationRequestToJSON,
    ProfileQualificationResourceFromJSON,
    ProfileQualificationResourceToJSON,
} from '../models';

export interface GetProfileQualificationRequest {
    profileId: string;
}

export interface UpsertProfileQualificationRequest {
    profileId: string;
    profileQualificationRequest: ProfileQualificationRequest;
}

/**
 * 
 */
export class ProfileQualificationApi extends runtime.BaseAPI {

    /**
     * Returns the profile qualification
          */
    async getProfileQualificationRaw(requestParameters: GetProfileQualificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileQualificationResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getProfileQualification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProfileQualificationResource>({
            path: `/profile/api/{profileId}/qualification`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProfileQualificationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the profile qualification
          */
    async getProfileQualification(requestParameters: GetProfileQualificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileQualificationResource> {
        const response = await this.getProfileQualificationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Upsert the profile qualification
          */
    async upsertProfileQualificationRaw(requestParameters: UpsertProfileQualificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileQualificationResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling upsertProfileQualification().'
            );
        }

        if (requestParameters['profileQualificationRequest'] == null) {
            throw new runtime.RequiredError(
                'profileQualificationRequest',
                'Required parameter "profileQualificationRequest" was null or undefined when calling upsertProfileQualification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProfileQualificationResource>({
            path: `/profile/api/{profileId}/qualification`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileQualificationRequestToJSON(requestParameters['profileQualificationRequest']),
        }, initOverrides);

        if (response._data) { response._data=ProfileQualificationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Upsert the profile qualification
          */
    async upsertProfileQualification(requestParameters: UpsertProfileQualificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileQualificationResource> {
        const response = await this.upsertProfileQualificationRaw(requestParameters, initOverrides);
        return response._data;
    }

}
